<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('baMedicine:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="药品编码">
                <a-input v-model="queryParam.medicinecode" allow-clear placeholder="请输入药品编码（药品唯一编码，各医疗机构药品编码）" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="药品名称">
                <a-input v-model="queryParam.medicinename" allow-clear placeholder="请输入药品名称" />
              </a-form-item>
            </a-col>
            <!-- <template v-if="advanced"> -->
            <!-- <a-col :md="8" :sm="24">
                <a-form-item label="拼音">
                  <a-input v-model="queryParam.pinyin" allow-clear placeholder="请输入拼音"/>
                </a-form-item>
              </a-col> -->
            <a-col :md="8" :sm="24">
              <a-form-item label="使用标记">
                <a-input v-model="queryParam.useflag" allow-clear placeholder="请输入使用标记（0-未启用-1-使用）" />
              </a-form-item>
            </a-col>
            <!-- <a-col :md="8" :sm="24">
              <a-form-item label="来源">
                <a-select v-model="queryParam.channel" placeholder="请选择来源">
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option value='0'>his</a-select-option>
                  <a-select-option value='1'>管理后台</a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <!-- </template> -->
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table ref="table" :columns="columns" :data="loadData" :alert="options.alert"
        :rowKey="(record) => record.medicineid" :rowSelection="options.rowSelection">
        <template class="table-operator" slot="operator" v-if="hasPerm('baMedicine:add')">
          <a-button type="primary" v-if="hasPerm('baMedicine:add')" icon="plus" @click="$refs.addForm.add()">新增中成药/西药信息表
          </a-button>
          <a-button type="danger" :disabled="selectedRowKeys.length < 1" v-if="hasPerm('baMedicine:delete')"
            @click="batchDelete">
            <a-icon type="delete" />批量删除
          </a-button>
          <x-down v-if="hasPerm('baMedicine:export')" ref="batchExport" @batchExport="batchExport" />
        </template>

        <span slot="medicinetype" slot-scope="text, record">
          {{ record.medicinetype == 1 ? '中成药' : record.medicinetype == 2 ? '西药' : '---' }}
        </span>
        <span slot="validDate" slot-scope="text, record">
          {{ record.validDate ? moment(record.validDate).format('YYYY-MM-DD') : '---' }}
        </span>
        <span slot="action" slot-scope="text, record">
          <a v-if="hasPerm('baMedicine:edit') && record.channel != 0" @click="$refs.editForm.edit(record)">编辑</a>
          <a-divider type="vertical" v-if="hasPerm('baMedicine:edit') & hasPerm('baMedicine:delete')" />
          <a-popconfirm v-if="hasPerm('baMedicine:delete')" placement="topRight" title="确认删除？"
            @confirm="() => singleDelete(record)">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </s-table>
      <add-form ref="addForm" @ok="handleOk" />
      <edit-form ref="editForm" @ok="handleOk" />
    </a-card>
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import { baMedicinePage, baMedicineDelete, baMedicineExport } from '@/api/modular/interhospital/bamedicine/baMedicineManage'
  import addForm from '../bamedicine/addForm.vue'
  import editForm from '../bamedicine/editForm.vue'
  import moment from 'moment'
  export default {
    components: {
      STable,
      addForm,
      editForm,
      XDown
    },
    data () {
      return {
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          // （药品唯一编码，各医疗机构药品编码）
          {
            title: '药品编码',
            align: 'center',
            dataIndex: 'medicinecode'
          },
          {
            title: '药品名称',
            align: 'center',
            dataIndex: 'medicinename'
          },
          // {
          //   title: '拼音',
          //   align: 'center',
          //   dataIndex: 'pinyin'
          // },
          // {
          //   title: '药品分类名称',
          //   align: 'center',
          //   dataIndex: 'mSortname'
          // },
          // （1中成药,2西药）
          {
            title: '药品类型',
            align: 'center',
            dataIndex: 'medicinetype',
            scopedSlots: { customRender: 'medicinetype' },
          },
          {
            title: '规格',
            align: 'center',
            dataIndex: 'specification'
          },
          // {
          //   title: '剂型名称',
          //   align: 'center',
          //   dataIndex: 'dosename'
          // },
          {
            title: '生产厂商名称',
            align: 'center',
            dataIndex: 'manuname',
            ellipsis : true
          },
          // {
          //   title: '供应商ID（暂不使用）',
          //   align: 'center',
          //   dataIndex: 'supplierid'
          // },
          // （来源ba_usage表的usagecode字段，过滤当前机构并且utype=3）
          // {
          //   title: '用药途径编码',
          //   align: 'center',
          //   dataIndex: 'usagecode'
          // },
          // (用药途径)
          // {
          //   title: 'usagename',
          //   align: 'center',
          //   dataIndex: 'usagename'
          // },
          // （最小服药单位编码）
          // {
          //   title: '基准单位编码',
          //   align: 'center',
          //   dataIndex: 'baseUnitid'
          // },
          // （最小服药单位）
          {
            title: '基准单位',
            align: 'center',
            dataIndex: 'baseUnit'
          },
          // {
          //   title: '剂量单位编码',
          //   align: 'center',
          //   dataIndex: 'mediUnitid'
          // },
          // {
          //   title: '剂量单位',
          //   align: 'center',
          //   dataIndex: 'mediUnit'
          // },
          // （最小发药单位）
          // {
          //   title: '最小包装单位',
          //   align: 'center',
          //   dataIndex: 'packageUnitid'
          // },
          {
            title: '包装单位',
            align: 'center',
            dataIndex: 'packageUnit'
          },
          // （与最小服药单位位进行转换：N 剂量单位 = 1 基准单位）
          // {
          //   title: '剂量单位转换系数',
          //   align: 'center',
          //   dataIndex: 'mediFactor'
          // },
          // （与最小发药单位进行转换：1 售价单位 = N 最小发药单位）
          // {
          //   title: '暂不使用—售价单位转换系数',
          //   align: 'center',
          //   dataIndex: 'feeFactor'
          // },
          // （与最小发药单位进行转换：1 包装单位 = N 最小发药单位）
          // {
          //   title: '最小包装单位转换系数',
          //   align: 'center',
          //   dataIndex: 'packageFactor'
          // },
          // （来源于频次表的freqcode字段，过滤当前机构）
          // {
          //   title: '频次code',
          //   align: 'center',
          //   dataIndex: 'freqcode'
          // },
          // {
          //   title: '频次名称',
          //   align: 'center',
          //   dataIndex: 'freqname'
          // },
          // {
          //   title: '默认频次天数',
          //   align: 'center',
          //   dataIndex: 'defDays'
          // },
          // {
          //   title: '默认频次次数',
          //   align: 'center',
          //   dataIndex: 'defTimes'
          // },
          // {
          //   title: '默认单次剂量',
          //   align: 'center',
          //   dataIndex: 'defDosage'
          // },
          // {
          //   title: '最大剂量',
          //   align: 'center',
          //   dataIndex: 'maxDosage'
          // },
          {
            title: '批准文号（国药准字或者注册号）',
            align: 'center',
            dataIndex: 'approveNo',
            ellipsis : true
          },
          {
            title: '有效期',
            align: 'center',
            dataIndex: 'validDate',
            scopedSlots: { customRender: 'validDate' },
          },
          // {
          //   title: '备注',
          //   align: 'center',
          //   dataIndex: 'remarks'
          // }
        ],
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return baMedicinePage(Object.assign(parameter, this.queryParam)).then((res) => {
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },
    created () {
      if (this.hasPerm('baMedicine:edit') || this.hasPerm('baMedicine:delete')) {
        this.columns.push({
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
      }
    },
    methods: {
      moment,
      /**
       * 单个删除
       */
      singleDelete (record) {
        const param = [{ 'medicineid': record.medicineid }]
        this.baMedicineDelete(param)
      },
      /**
       * 批量删除
       */
      batchDelete () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'medicineid': d }
        })
        this.baMedicineDelete(paramIds)
      },
      baMedicineDelete (record) {
        baMedicineDelete(record).then((res) => {
          if (res.success) {
            this.$message.success('删除成功')
            this.$refs.table.clearRefreshSelected()
          } else {
            this.$message.error('删除失败') // + res.message
          }
        })
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      /**
       * 批量导出
       */
      batchExport () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'medicineid': d }
        })
        baMedicineExport(paramIds).then((res) => {
            this.$refs.batchExport.downloadfile(res)
        })
      },
      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      }
    }
  }
</script>
<style lang="less" scoped>
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
  
</style>
